import React from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const ContactInformation = () => {
  const contactMethods = [
    {
      id: "phone",
      title: "Automotive Helpline",
      description: "Speak directly with our parts specialists",
      icon: "Phone",
      primary: "+91 8573036150",
      link: "tel:+918573036150",
      availability: "Mon-Sat: 10:30 AM - 8:00 PM",
      action: "Call Now",
      urgent: true,
    },
    {
      id: "whatsapp",
      title: "WhatsApp Support",
      description: "Share photos for instant part ID",
      icon: "MessageSquare",
      primary: "+91 7266929245",
      link: "https://wa.me/917266929245",
      availability: "24/7 Emergency Support Available",
      action: "Chat on WhatsApp",
      urgent: true,
    },
    {
      id: "email",
      title: "Email Support",
      description: "Detailed technical queries and documentation",
      icon: "Mail",
      primary: "contact@kharbandamotors.com",
      link: "mailto:contact@kharbandamotors.com",
      availability: "Response within 4-6 hours",
      action: "Send Email",
      urgent: true,
    },
  ];

  return (
    <div className="space-y-8">
      {/* Primary Contact Methods */}
      <div className="bg-white rounded-lg shadow-automotive-md p-6 border border-border">
        <div className="flex items-center space-x-3 mb-6">
          <div className="flex items-center justify-center w-12 h-12 bg-accent rounded-lg">
            <Icon name="Phone" size={24} color="white" strokeWidth={2} />
          </div>
          <div>
            <h3 className="text-xl font-bold text-text-primary">
              Get In Touch
            </h3>
            <p className="text-sm text-text-secondary">
              Multiple ways to reach our automotive experts
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {contactMethods.map((method) => (
            <div key={method.id} className="relative">
              <div
                className={`p-4 rounded-lg border-2 transition-all duration-normal hover:shadow-automotive-md ${
                  method.urgent
                    ? "border-accent bg-accent/5 hover:border-accent/70"
                    : "border-border bg-white hover:border-accent/50"
                }`}
              >
                <div className="flex items-center space-x-3 mb-3">
                  <div
                    className={`flex items-center justify-center w-10 h-10 rounded-lg ${
                      method.urgent
                        ? "bg-accent text-white"
                        : "bg-muted text-text-primary"
                    }`}
                  >
                    <Icon name={method.icon} size={20} strokeWidth={2} />
                  </div>
                  <div>
                    <h4 className="font-semibold text-text-primary">
                      {method.title}
                    </h4>
                  </div>
                </div>

                <p className="text-sm text-text-secondary mb-3">
                  {method.description}
                </p>

                <div className="space-y-2 mb-4">
                  {/* Clickable Contact Info */}
                  <a
                    href={method.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center space-x-2 hover:text-accent transition"
                  >
                    <Icon name="Contact" size={14} className="text-accent" />
                    <span className="text-sm font-medium text-text-primary">
                      {method.primary}
                    </span>
                  </a>

                  <div className="flex items-center space-x-2">
                    <Icon
                      name="Clock"
                      size={14}
                      className="text-text-secondary"
                    />
                    <span className="text-xs text-text-secondary">
                      {method.availability}
                    </span>
                  </div>
                </div>

                {/* Action Button (Clickable) */}
                <a href={method.link} target="_blank" rel="noopener noreferrer">
                  <Button
                    variant={method.urgent ? "default" : "outline"}
                    size="sm"
                    fullWidth
                    iconName={method.icon}
                    iconPosition="left"
                    className={method.urgent ? "bg-accent text-white" : ""}
                  >
                    {method.action}
                  </Button>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactInformation;
